import React, { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { api, DUCK_LOGO, formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ResetPassword() {
  const loc = useLocation();
  const nav = useNavigate();
  const token = new URLSearchParams(loc.search).get("token") || "";
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (next.length < 8) return setErr("Password must be at least 8 characters.");
    if (next !== confirm) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: next });
      toast.success("Password reset. Sign in with your new password.");
      nav("/login");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="w-full max-w-md p-8 rounded-2xl cq-in" data-testid="reset-card">
        <Link to="/" data-testid="rp-brand-home" aria-label="Back to home"><img src={DUCK_LOGO} alt="" className="h-14 w-14 object-contain hover:scale-105 transition" /></Link>
        <h1 className="font-display text-3xl font-black mt-4">Set a new password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div><Label>New password</Label><Input type="password" value={next} onChange={(e) => setNext(e.target.value)} required data-testid="reset-new" /></div>
          <div><Label>Confirm password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm" /></div>
          {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
          <Button type="submit" disabled={busy || !token} className="w-full bg-amber-500 hover:bg-amber-600 h-11 rounded-xl" data-testid="reset-submit">
            {busy ? "Saving…" : "Reset password"}
          </Button>
          {!token && <p className="text-xs text-red-500">Missing reset token in URL.</p>}
        </form>
        <p className="mt-6 text-sm text-slate-500"><Link to="/login" className="text-amber-600 font-bold">Back to sign in</Link></p>
      </Card>
    </div>
  );
}
